import { logError } from 'loggingManager';
import { axiosWithAuth } from 'interceptors/auth.interceptor';

export interface McpProduct {
    mcpSku: string;
    name: string;
}

export async function getProduct(productSku: string) {
    const url = `https://product-orchestration.products.cimpress.io/v1/products/${productSku}/metadata`;
    return axiosWithAuth.get(url)
        .then((response) => {
            const { name, productId: sku, current: skuVersion } = response.data;
            return { name, sku, skuVersion };
        })
        .catch((error) => {
            logError(`Could not fetch product ${error}`);
        });
}
